import React from 'react';
import { FaqMain } from '../../../../types/puppyGuide';

export const faq: FaqMain = {
  title: 'Vets Want You to Know',
  faqs: [
    {
      title: 'Teething is normal, but not all puppy chew toys are created equal.',
      answer: (
        <React.Fragment>
          <p>
            At 12 to 24 weeks, baby teeth start to fall out and are replaced by permanent teeth.
            This is the peak stage of teething activity. It’s usually the most uncomfortable time
            for puppies and the most frustrating time for pet parents.
          </p>
          <p>
            It is critical that you choose toys for your puppy that will help to ease the pain of
            teething and keep your puppy from chewing on furniture, shoes, your toes, or even other
            pets.
          </p>
          While items like antlers, natural chews, and bones might be appealing as alternatives to
          plastic, plush, or rubber toys, these items can be just as dangerous to your puppy. Common
          injuries can include:
          <ul>
            <li>Fractured teeth or punctures to the oral cavity</li>
            <li>
              Perforation of the esophagus, stomach, or intestine (particularly if the bone or hoof
              becomes splintered)
            </li>
            <li>Intestinal obstruction if a large portion is swallowed whole</li>
          </ul>
          <p>
            For chew toy tips and tricks, check out this puppy teething guide:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/care/get-right-puppy-teething-toys-each-puppy-stage"
            >
              How to Pick the Best Chew Toys for Puppies
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Mental stimulation is great for getting rid of puppy energy.',
      answer: (
        <React.Fragment>
          <p>
            When most pet parents think of exercise and stimulation for puppies, they think of going
            for walks, playing fetch, or other physically intensive activities. But those are not
            your only options.
          </p>
          <p>
            Puppies greatly benefit from activities that provide mental stimulation—and these
            activities can be equally exhausting, or more, than your standard walk. Activities that
            include engaging your dog’s senses and intellect, like puzzle toys and scent work, can
            be great ways to expend your puppy’s energy.
          </p>
          <p>
            Relieving puppy boredom and potentially destructive or chaotic energy is not the only
            benefit of mentally stimulating toys either. These types of activities also help with
            building up your puppy’s confidence and strengthening the bond between you both.
          </p>
          <p>
            Here are a few guides and resources to help you learn more about mentally stimulating
            activities for puppies and dogs in general:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://be.chewy.com/3-reasons-get-dog-puzzle-toy/"
            >
              3 Reasons to Get Your Dog a Puzzle Toy
            </a>
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/behavior/importance-scent-walks-dogs"
            >
              The Importance of &apos;Scent Walks&apos; for Dogs
            </a>
            <br />
            <a target="_blank" rel="noreferrer" href="https://be.chewy.com/nose-work-training/">
              Benefits of Nose Work Training for Dogs
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Puppy-proofing your home can keep your pup safe.',
      answer: (
        <React.Fragment>
          <p>
            You can start puppy-proofing a house by walking around your entire home, including the
            yard, and imagining what a puppy could eat, climb, or pull down. Once you have
            identified these objects, you can remove them.
          </p>
          <p>
            Don’t forget to get down on your knees to see the home from your puppy’s perspective,
            which might help you discover hidden dangers. And remember, anything you’d take away
            from a toddler, you should keep out of reach from your new puppy, too.
          </p>
          <p>
            Follow these guides for puppy-proofing around your home:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/puppycenter/adoption-getting-a-puppy/evr_dg_puppy_proofing_checklist"
            >
              Puppy-Proofing Checklist
            </a>
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://be.chewy.com/puppy-proofing-the-stairs/"
            >
              Puppy-Proofing the Stairs
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Dog beds can harbor pests and germs.',
      answer: (
        <React.Fragment>
          <p>
            Sure, you’re not the one sleeping there, but you likely come in secondhand contact with
            your dog’s bed multiple times a day, every day. Whenever your dog moves from their bed
            to your couch or comes to you for a quick belly rub, they’re dragging an invisible cloud
            of germs everywhere they go. Fortunately, dog beds and mats are items you can maintain a
            thorough cleaning schedule over.
          </p>
          <p>
            A good guideline to follow includes washing your dog’s bed once a week or once every two
            weeks at minimum.
          </p>
          <p>
            Follow this guide to keep your puppy’s dog bed clean and tidy:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/care/evr_dg_guide-to-washing-dog-bed"
            >
              The Guide to Washing a Dog Bed
            </a>
          </p>
        </React.Fragment>
      ),
    },
  ],
};
